import { gql } from '@apollo/client';

export const UPDATE_AD = gql`
  mutation editAd($input: AdInput) {
    editAd(input: $input) {
      ad {
        id
        adName
      }
    }
  }
`;
